document.addEventListener("DOMContentLoaded", function () {
  const track = document.querySelector(".carousel-track");
  const originalSlides = Array.from(document.querySelectorAll(".carousel-slide"));
  const prevButton = document.querySelector(".carousel-prev");
  const nextButton = document.querySelector(".carousel-next");

  const slidesPerView = 4;
  let isMobile = window.innerWidth <= 768;
  let visibleSlides = isMobile ? 1 : slidesPerView;

  // Clonar solo los necesarios para el efecto infinito
  const clonesBefore = originalSlides.slice(-visibleSlides).map(slide => slide.cloneNode(true));
  const clonesAfter = originalSlides.slice(0, visibleSlides).map(slide => slide.cloneNode(true));

  clonesBefore.forEach(clone => track.insertBefore(clone, track.firstChild));
  clonesAfter.forEach(clone => track.appendChild(clone));

  // Actualizar lista de slides ya con clones
  let slides = Array.from(document.querySelectorAll(".carousel-slide"));
  const totalSlides = slides.length;
  const slideWidth = slides[0].offsetWidth + (isMobile ? 20 : 0);

  // Iniciar en el primer slide real (después de los clones al inicio)
  let index = visibleSlides;

  function setInitialPosition() {
    let offset = (window.innerWidth - slideWidth * visibleSlides) / 2;
    track.style.transition = "none";
    track.style.transform = `translateX(calc(-${index * slideWidth}px + ${offset}px))`;
  }

  function updateCarousel() {
    let offset = (window.innerWidth - slideWidth * visibleSlides) / 2;
    track.style.transition = "transform 0.5s ease-in-out";
    track.style.transform = `translateX(calc(-${index * slideWidth}px + ${offset}px))`;

    setTimeout(() => {
      if (index >= totalSlides - visibleSlides) {
        track.style.transition = "none";
        index = visibleSlides;
        setInitialPosition();
      } else if (index < visibleSlides) {
        track.style.transition = "none";
        index = totalSlides - (2 * visibleSlides);
        setInitialPosition();
      }
    }, 500);
  }

  nextButton.addEventListener("click", () => {
    index++;
    updateCarousel();
  });

  prevButton.addEventListener("click", () => {
    index--;
    updateCarousel();
  });

  // Swipe en móvil
  let isDragging = false;
  let startX = 0;
  let moveX = 0;
  const threshold = slideWidth / 4;

  track.addEventListener("touchstart", function (e) {
    isDragging = true;
    startX = e.touches[0].clientX;
    moveX = 0;
    track.style.transition = "none";
  });

  track.addEventListener("touchmove", function (e) {
    if (!isDragging) return;
    let currentX = e.touches[0].clientX;
    moveX = currentX - startX;
    track.style.transform = `translateX(${moveX - index * slideWidth}px)`;
  });

  track.addEventListener("touchend", function () {
    isDragging = false;
    if (Math.abs(moveX) > threshold) {
      index += moveX < 0 ? 1 : -1;
    }
    updateCarousel();
  });

  // Responsive
  window.addEventListener("resize", function () {
    isMobile = window.innerWidth <= 768;
    visibleSlides = isMobile ? 1 : slidesPerView;
    index = visibleSlides;
    setInitialPosition();
  });

  // Posición inicial
  setInitialPosition();
});
